<div *ngIf="subscriptionPlan != null && !showPaymentModal" class="dc-container">
  <!-- <button (click)="makePayment()">Make Payment</button> -->
  <!-- <button (click)="downloadCertificate()" >Download File</button> -->
  <div class="Waves">
    <wave-component [isTyping]="isLoading"></wave-component>
  </div>

  <div class="dc-user-interaction">
    <div class="dc-chat-container" #chatContainer>
      <ng-container *ngFor="let message of messages$ | async">
        <chat-bubble-user *ngIf="message.type === 'user' && message.content !== 'Hi'"
          [message]="message.content"></chat-bubble-user>
        <app-chat-bubble-ai *ngIf="message.type === 'ai'" [message]="message.content"
          [files]="message.files"></app-chat-bubble-ai>
      </ng-container>
    </div>
    <!-- <button>Go Back</button> -->
    <button *ngIf="showCloseChatButton" (click)="closeChat()"
      class="rounded-full bg-[#289DD2] text-white px-6 py-2 hover:bg-[#1f86b3] focus:outline-none focus:ring-2 focus:ring-[#1f86b3] focus:ring-offset-2  w-fit self-center text-sm sticky bottom-0 mt-auto">
      Close chat
    </button>


    <div class="dc-input-container" *ngIf="!showCloseChatButton">
      <form class="dc-input-form" (submit)="onSubmit($event)">
        <input type="text" [placeholder]="isLoading? 'AI is thinking...' : 'Type your message here...'"
          class="dc-input-text" [(ngModel)]="userInput" (input)="handleInput($event)" name="userInput"
          [disabled]="isLoading">
        <button type="submit">
          <i class="fa-regular fa-circle-right"></i>
        </button>
      </form>
    </div>
  </div>

</div>
<app-payment-popup class="app-payment-popup" *ngIf="showPaymentModal" [showPaymentModal]="showPaymentModal"
  [session]="session" (closePaymentModal)="closePaymentModal()" (paymentSuccess)="handlePaymentSuccess()">
</app-payment-popup>